import {
  BodyText,
  Field,
  FieldError,
  HeaderText,
  RadioGroup,
} from "@/components/ui";
import { programTrackDisplayName } from "@/constants/AccessProgram";
import type { EncounterProgram } from "@curai/js-fhir-tools";
import { Controller, type UseFormReturn } from "react-hook-form";
import type { VisitClosureFormData, VisitClosureFormInput } from "../schemas";

interface ProgramEnrollmentStepProps {
  form: UseFormReturn<VisitClosureFormInput, unknown, VisitClosureFormData>;
  encounterProgram: EncounterProgram;
}

export const ProgramEnrollmentStep = ({
  form,
  encounterProgram,
}: ProgramEnrollmentStepProps) => {
  const trackDisplay = programTrackDisplayName(encounterProgram.type);
  const enrollmentOptions = [
    { label: "Not approved", value: "false" },
    {
      label: `Yes, approved for ${trackDisplay} ACCESS program`,
      value: "true",
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <HeaderText size="sm" tag="h3">
        ACCESS Enrollment
      </HeaderText>
      <BodyText size="sm">
        Do you approve their eligibility into the {trackDisplay} ACCESS program?
      </BodyText>
      <BodyText size="sm">
        To enroll in ACCESS, a patient must have a diagnosis involved in ACCESS.
        Please refer to Notion if not sure of the details.
      </BodyText>
      <Controller
        control={form.control}
        name="programEnrollment.enrollmentApproved"
        render={({ field, fieldState }) => (
          <Field data-invalid={fieldState.invalid}>
            <RadioGroup
              name={field.name}
              orientation="vertical"
              options={enrollmentOptions}
              onValueChange={(v: string) => field.onChange(v === "true")}
              value={
                field.value === null || field.value === undefined
                  ? ""
                  : String(field.value)
              }
              aria-invalid={fieldState.invalid}
            />
            <FieldError errors={[fieldState.error]} />
          </Field>
        )}
      />
    </div>
  );
};
